import React from 'react'
import PropTypes from 'prop-types'
import { isK5Url, isMiddleSchoolUrl } from 'utils/routing/routeHelpers'
import MarkCompleteButtonIcon from 'components/MarkCompleteButtonIcon'
import {
  StyledHeader4,
  StyledParagraph,
  SectionWrapper,
  StatusColumn,
  NextColumn,
  MarkCompleteButton,
  NextSectionButton,
  MarkCompleteButtonWrapper,
  MarkCompleteButtonIconWrapper,
  MarkCompleteIcon,
  CompletionCommentary,
  getCompleteIconColor,
} from './component.styles'

export default function MarkCompleteSection({
  buttonText = 'Mark Complete',
  completeText = 'Complete',
  completionCommentaryComplete = undefined,
  completionCommentaryTodo = undefined,
  handleClickNext = () => {},
  hasPermissionsToComplete = true,
  id,
  isComplete = false,
  nextSectionButtonText = undefined,
  nextSectionPromptText = undefined,
  onMarkComplete = () => {},
  promptText,
  shoulDisplayCompletionDetails = false,
}) {
  return (
    <SectionWrapper id={id}>
      <StatusColumn>
        <StyledHeader4>{promptText}</StyledHeader4>
        <MarkCompleteButtonWrapper>
          <MarkCompleteButton
            hasPermissionsToComplete={hasPermissionsToComplete}
            isComplete={isComplete}
            onClick={onMarkComplete}
          >
            {(hasPermissionsToComplete || isComplete) && (
              <>
                {isComplete ? (
                  // this can only render the complete icon
                  // because the incomplete version requires a transparent cut out that's
                  // easier to render as an SVG background image
                  <MarkCompleteButtonIconWrapper>
                    <MarkCompleteButtonIcon
                      fillColor={getCompleteIconColor({
                        isK5: isK5Url(),
                        isMiddleSchool: isMiddleSchoolUrl(),
                      })}
                    />
                  </MarkCompleteButtonIconWrapper>
                ) : (
                  <MarkCompleteIcon isComplete={false} />
                )}
              </>
            )}
            {isComplete ? completeText : buttonText}
          </MarkCompleteButton>
          {(!!completionCommentaryTodo || !!completionCommentaryComplete) &&
            shoulDisplayCompletionDetails && (
              <CompletionCommentary isComplete={isComplete}>
                {isComplete
                  ? completionCommentaryComplete
                  : completionCommentaryTodo}
              </CompletionCommentary>
            )}
        </MarkCompleteButtonWrapper>
      </StatusColumn>
      {hasPermissionsToComplete &&
        (!!nextSectionButtonText || !!nextSectionPromptText) && (
          <NextColumn>
            {!!nextSectionPromptText && (
              <StyledParagraph>{nextSectionPromptText}</StyledParagraph>
            )}
            {!!nextSectionButtonText && (
              <NextSectionButton
                isComplete={isComplete}
                onClick={handleClickNext}
              >
                {nextSectionButtonText}
              </NextSectionButton>
            )}
          </NextColumn>
        )}
    </SectionWrapper>
  )
}

MarkCompleteSection.propTypes = {
  buttonText: PropTypes.string,
  completeText: PropTypes.string,
  completionCommentaryComplete: PropTypes.string,
  completionCommentaryTodo: PropTypes.string,
  handleClickNext: PropTypes.func,
  hasPermissionsToComplete: PropTypes.bool,
  id: PropTypes.string,
  isComplete: PropTypes.bool,
  nextSectionButtonText: PropTypes.string,
  nextSectionPromptText: PropTypes.string,
  onMarkComplete: PropTypes.func,
  promptText: PropTypes.string,
  shoulDisplayCompletionDetails: PropTypes.bool,
}
